import { Component, ViewChild, HostListener, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlModelsService } from '../ll-models.service';
import { UserService } from '../../services/user.service';
import { LlUtilityService } from '../ll-utility.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";

@Component({
  selector: 'll-model-cash-reconcile-switch',
  templateUrl: './ll-model-cash-reconcile-switch.component.html',
  styleUrl: './ll-model-cash-reconcile-switch.component.css'
})
export class LlModelCashReconcileSwitchComponent {

  @ViewChild('mainDiv_ll_model_cash_reconcile_switch') mainDiv: ElementRef;
  @ViewChild('datagrid_ll_model_cash_reconcile_switch') datagrid!: jqxGridComponent;
  @ViewChild('popover_userNotes_ll_model_cash_reconcile_switch') popover_userNotes!: jqxPopoverComponent;
  constructor(
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,
    private LlModelsService: LlModelsService,
    private LlUtilityService: LlUtilityService,
    private UserService: UserService,
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    showGrid: false,
    showSelectAll: false,
    allSelected: false,
    canManualMatch: false,
    mode: '',
    function: '',
    LlScrollpaneService: this.LlScrollpaneService,
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 40,
    remainingW: 0,
    remainingH: 0,
    gridX: 0,
    gridY: 50,
    gridW: 0,
    gridH: 0,
    showTab: true,
    horzTabsY: 20,
    hTabW: 120,
    hTabH: 15,
    hTabIndent: 50,
    hTabIndx: 0,
    genTabs: [],
    bankTabs: [],
    remitTabs: [],
    canvasHT: {},
    ctxHT: {},
    activeCODE: "List",
    monthList: [] as any[],
    locationList: [] as any[],
    stateList: [] as any[],
    divisionList: [] as any[],
    bankAccountList: [] as any[],
    records: [] as any[],
    columns: [] as any[],
    userChoices: [] as any[],
    userNotes: [] as any[],
    remitsByAmount: [] as any[],
    activeRowIndex: 0,
    newUSERNOTE: '',
    newCASHUSERCHOICEID: 0,
    newCashBankLocationAccountId: 0,
    selectedRecords: [] as any[],
    monthChoice: '',
    locationIdChoice: 0,
    stateIdChoice: 0,
    divisionIdChoice: 0,
    fileLabel:'',
  }

  ngOnInit() { }

  eventSubscription_ll_model_cash_switch: any;

  ngOnDestroy() {
    this.eventSubscription_ll_model_cash_switch.unsubscribe();
  }

  ngAfterViewInit() {


    this.eventSubscription_ll_model_cash_switch = this.LlModelsService.ll_model_cash_switch.subscribe(action => {
      this.bundle.mode = action;
    });

    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;
    this.bundle.canManualMatch = this.LlPermissionsService.check("canManMtchBnkRecds")

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingX = 0;
      this.bundle.remainingW = this.bundle.parentW;;
      this.bundle.gridW = this.bundle.remainingW;

      this.calculateGridYLocation(70);
      this.getData()
    });
  }

  calculateGridYLocation(offSet) {
    this.bundle.remainingY = this.bundle.horzTabsY + this.bundle.hTabH + offSet
    this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;
    this.bundle.gridH = this.bundle.remainingH - 45;
  }

  getData() {

    ///this.bundle.activeCODE = "Auto-Match";
    this.bundle.activeCODE = "locations";

    this.bundle.genTabs.splice(0);
    this.bundle.genTabs.push({ LABEL: "Locations", CODE: "locations" });

    ///this.bundle.genTabs.push({ LABEL: "Auto-Match", CODE: "Auto-Match" });

    this.bundle.bankTabs.splice(0);
    this.bundle.bankTabs.push({ LABEL: "All", CODE: "Bank-Matched-All" });
    this.bundle.bankTabs.push({ LABEL: "Yes", CODE: "Bank-Matched-Yes" });
    this.bundle.bankTabs.push({ LABEL: "No", CODE: "Bank-Matched-No" });   

    this.bundle.remitTabs.splice(0);
    this.bundle.remitTabs.push({ LABEL: "All", CODE: "Remit-Matched-All" });
    this.bundle.remitTabs.push({ LABEL: "Yes", CODE: "Remit-Matched-Yes" });
    this.bundle.remitTabs.push({ LABEL: "No", CODE: "Remit-Matched-No" });  

    this.LlModelsService.NG_LL_model_AR_cash_resetActiveSettings() 

    this.LlModelsService.NG_LL_model_AR_cash_monthList_get((arr: any[]) => {
     
      this.bundle.monthList = arr || [];

      this.bundle.monthChoice = this.bundle.monthList[0].CHOICE;
    
      this.LlModelsService.NG_LL_model_AR_cash_list_location_get((arr: any[]) => {

        this.bundle.locationList = arr || [];

        this.LlModelsService.NG_LL_model_AR_cash_list_state_get((arr: any[]) => {

          this.bundle.stateList = arr || [];

          this.bundle.stateIdChoice = this.bundle.stateList[0].STATEID;         

          this.LlModelsService.NG_LL_model_AR_cash_list_userChoices_get((arr: any[]) => {

            this.bundle.userChoices = arr || [];

            this.LlModelsService.NG_LL_model_AR_cash_list_cashBankAccount_get((arr: any[]) => {

              this.bundle.bankAccountList = arr || [];

              this.getGridData();

              this.bundle.showHorzTabs = true;
              this.bundle.showRemaining = true;


            });

          });

        });


      });


    });

  }

  getGridData() {

    this.bundle.showGrid = false;
    this.bundle.showSelectAll = false;

    if (this.bundle.activeCODE === "Auto-Match") {

      this.bundle.showSelectAll = true;

      this.calculateGridYLocation(90);

      this.LlModelsService.NG_LL_model_AR_cash_reconcileList_suggested_get(
        (arr: any[]) => {
          this.bundle.records = arr || [];
          this.paintGrid();
        },
        "Match"
      );

    } else if (this.bundle.activeCODE === "locations") {

        this.bundle.showSelectAll = true;

       /// this.calculateGridYLocation(90);

      this.LlModelsService.NG_LL_model_AR_cash_reconcileList_byLocation_get(
          (arr: any[]) => {
            this.bundle.records = arr || [];
            this.paintGrid();
          }
        );


    } else if (this.bundle.activeCODE === "Bank-Matched-All" || this.bundle.activeCODE === "Bank-Matched-Yes" || this.bundle.activeCODE === "Bank-Matched-No") {

      this.calculateGridYLocation(65);

      var ACTION = "All";

      if (this.bundle.activeCODE === "Bank-Matched-Yes") {
        ACTION = "Yes";
      } else if (this.bundle.activeCODE === "Bank-Matched-No") {
        ACTION = "No";
      }

      this.LlModelsService.NG_LL_model_AR_cash_reconcileList_matched_get(
        (arr: any[]) => {
          this.bundle.records = arr || [];
          
          this.paintGrid();
        },
        ACTION
      );

    } else if (this.bundle.activeCODE === "Remit-Matched-All" || this.bundle.activeCODE === "Remit-Matched-Yes" || this.bundle.activeCODE === "Remit-Matched-No") {

      this.calculateGridYLocation(65);

      var ACTION = "All";

      if (this.bundle.activeCODE === "Remit-Matched-Yes") {
        ACTION = "Yes";
      } else if (this.bundle.activeCODE === "Remit-Matched-No") {
        ACTION = "No";
      }

      this.LlModelsService.NG_LL_model_AR_cash_remits_matched_get(
        (arr: any[]) => {
          this.bundle.records = arr || [];
          this.paintGrid();
        },
        ACTION
      );

    }


  };

  paintGrid(): void {

    //console.log(this.bundle.records)

    const floatCellsRenderer = (row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any) => {
      if (value === null || value === undefined || value === '') {
        return '<span style="margin: 4px; float: right;"></span>';
      }

      const num = typeof value === 'number' ? value : parseFloat(value);
      const formatted = isNaN(num)
        ? value
        : num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

      return `<span style="margin: 4px; float: ${columnproperties.cellsalign || 'right'};">${formatted}</span>`;
    };

    if (!this.datagrid) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintGrid(), 100);
      return;
    }

    var fields = [];
    var columns = [];

    let colW01 = 0;
    let colW02 = 0;
    let colW03 = 0;
    let colW04 = 0;
    let colW05 = 0;
    let colW06 = 0;
    let colW07 = 0;
    let colW08 = 0;
    let colW09 = 0;
    let colW10 = 0;
    let colW11 = 0;
    let colW12 = 0;
    let colW13 = 0;
    let remainingW = 0;

  if (this.bundle.activeCODE === "locations") {
      columns.push({ text: 'Location', datafield: 'LOCATIONNAME', columntype: 'string', width: 200, editable: true, dataType: 'string', });
      columns.push({ text: 'State', datafield: 'STATENAME', columntype: 'string', width: 50, editable: true, dataType: 'string', });
    columns.push({ text: 'Bank Amount', datafield: 'BANKAMOUNT', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
    columns.push({ text: 'Remit Amount', datafield: 'REMITAMOUNT', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });

      columns.push({ text: 'Difference', datafield: 'AMOUNTDIFF', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
      //columns.push({ text: 'Matched Amount', datafield: 'MATCHEDAMOUNT', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
      columns.push({ text: 'Bank Unmatched', datafield: 'UNMATCHEDBANKAMOUNT', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
      columns.push({ text: 'Remit Unmatched', datafield: 'UNMATCHEDREMITAMOUNT', columntype: 'string', width: 150, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });



    } else if (this.bundle.activeCODE === "Bank-Matched-All" || this.bundle.activeCODE === "Bank-Matched-Yes" || this.bundle.activeCODE === "Bank-Matched-No") {
      columns.push({ text: '', datafield: 'EDITLOC', cellsrenderer: editGear, width: 25, editable: false, });
      columns.push({ text: 'Location', datafield: 'LOCATIONNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });
      columns.push({ text: 'State', datafield: 'STATENAME', columntype: 'string', width: 50, editable: true, dataType: 'string', });
      columns.push({ text: 'Bank Date', datafield: 'BANKDATE_FORMATED', columntype: 'string', width: 90, editable: false, dataType: 'string', });
      ///columns.push({ text: 'Entry Type', datafield: 'ENTRYTYPE', columntype: 'string', width: colW06, editable: false, dataType: 'string', });
      columns.push({ text: 'Bank Entry Detail', datafield: 'ENTRYDETAIL', columntype: 'string', width: 175, editable: false, dataType: 'string', });

      if (this.bundle.activeCODE === "Bank-Matched-No") {
        columns.push({ text: 'Unmatched Amt', datafield: 'AMOUNTDIFF', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
        columns.push({ text: '', datafield: 'NOTES', cellsrenderer: notePencil, width: 25, editable: false, });
        columns.push({ text: 'Reason', datafield: 'CASHUSERCHOICE', columntype: 'string', width: 250, editable: false, dataType: 'string', });

        if (this.bundle.canManualMatch) {
          columns.push({ text: 'Manual', datafield: 'MANUAL', columntype: 'checkbox', width: 70, editable: true, align: 'center' });
        }

        columns.push({ text: 'Note', datafield: 'LASTUSERCHOICENOTE', columntype: 'string', width: 250, editable: false, dataType: 'string', });


      } else {
        columns.push({ text: 'Bank Amount', datafield: 'ENTRYAMOUNT', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
   
        if (this.bundle.activeCODE === "Bank-Matched-All") { 
          columns.push({ text: 'Unmatched Amt', datafield: 'AMOUNTDIFF', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
        }

        columns.push({ text: 'Match Reason', datafield: 'MATCHREASON', columntype: 'string', width: 250, editable: false, dataType: 'string', });

        if (this.bundle.activeCODE === "Bank-Matched-Yes" && this.bundle.canManualMatch) {
          ///columns.push({ text: 'Manual', datafield: 'MANUAL', columntype: 'checkbox', width: 70, editable: true, align: 'center' });
        }


        columns.push({ text: 'Applied Rule-In Rule(s)', datafield: 'RULES', columntype: 'string', width: 100, editable: false, dataType: 'string', });
      }

      columns.push({ text: 'Bank', datafield: 'BANKNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });
      columns.push({ text: 'SysID', datafield: 'CASHFROMBANKID', columntype: 'string', width: 70, editable: false, dataType: 'string', hidden: false, });


    } else if (this.bundle.activeCODE === "Remit-Matched-All" || this.bundle.activeCODE === "Remit-Matched-Yes" || this.bundle.activeCODE === "Remit-Matched-No") {

    
      columns.push({ text: 'Location', datafield: 'LOCATIONNAME', columntype: 'string', width: 150, editable: true, dataType: 'string', });
      columns.push({ text: 'State', datafield: 'STATENAME', columntype: 'string', width: 50, editable: true, dataType: 'string', });

      columns.push({ text: 'Remit Date', datafield: 'REMITDATE_FORMATED', columntype: 'string', width: 90, editable: false, dataType: 'string', });
      columns.push({ text: 'Remit Desc.', datafield: 'DEPOSITDESCRIPTION', columntype: 'string', width: 170, editable: false, dataType: 'string', });

      if (this.bundle.activeCODE === "Remit-Matched-No") {
        columns.push({ text: 'Unmatched Amt', datafield: 'AMOUNTDIFF', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
      } else {

        columns.push({ text: 'Remit Amount', datafield: 'BATCHTOTALAMOUNT', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });

        if (this.bundle.activeCODE === "Remit-Matched-All") {
          columns.push({ text: 'Unmatched Amt', datafield: 'AMOUNTDIFF', columntype: 'string', width: 100, editable: false, dataType: 'float', cellsalign: 'right', cellsformat: 'f2', });
        }else{
          columns.push({ text: 'Match Reason', datafield: 'MATCHREASON', columntype: 'string', width: 250, editable: false, dataType: 'string', });

        }
      }

     columns.push({ text: 'Bank', datafield: 'BANKNAME', columntype: 'string', width: 100, editable: true, dataType: 'string', });
      columns.push({ text: 'SysID', datafield: 'CASHREMITBATCHID', columntype: 'string', width: 70, editable: false, dataType: 'string', });

    }

    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];

      if (col.dataType === 'float') {
        // Ensure 2 decimal places for every float column
        col.cellsformat = 'f2';
        col.cellsalign = 'right';
        col.cellsrenderer = floatCellsRenderer

        fields.push({
          name: col.datafield,
          type: 'number'
        });
      } else {
        fields.push({
          name: col.datafield,
          type: 'string'
        });
      }
    }

    this.bundle.columns = columns;

    setTimeout(() => {
      const source = { localdata: this.bundle.records, datatype: 'array', fields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.datagrid.source(dataAdapter);
      this.datagrid.columns(columns);
      this.datagrid.width(this.bundle.gridW);
      this.datagrid.height(this.bundle.gridH);
      this.datagrid.updatebounddata();

      this.datagrid.refresh();
      this.datagrid.render();

    }, 0);

    this.bundle.showGrid = true;

   

    function editGear(row: number, column: any, value: string) {
      var img = '<div class="editGear" [id]="EDIT" height:18px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_gear.png" ></div>';

      return img;
    }

    function notePencil(row: number, column: any, value: string) {
      var img = '<div  class="notePencil" [id]="NOTE" height:20px style="background: transparent; text-align: center; padding-top: 1px;"><img height="14" style="width: auto;"  src="assets/icon_pencil.png" ></div>';

      return img;
    } 

  }

  clickOnRow(event: any): void {

    console.log("clickOnRow")

    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;

    //if (this.bundle.activeCODE === "Auto-Match" ) {

    //  if (newValue == true) {
    //    this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Accept');

    //  } else if (newValue == false) {
    //    this.LlModelsService.NG_LL_model_AR_cash_reconcileList_single_edit(this.bundle.records[rowIndex], 'Reject');
    //  }
    //}

    this.showUserNotesPopup = false;
    this.showEditLocPopup = false;

    //console.log("this.bundle.activeCODE: " + this.bundle.activeCODE)
    //console.log("dataField: " + dataField)
    //console.log("newValue: " + newValue)


    if (dataField === 'MANUAL' && this.bundle.activeCODE === "Bank-Matched-No") {

      this.bundle.activeRowIndex = rowIndex;
      let MANUALVal = this.datagrid.getcellvalue(rowIndex, 'MANUAL');

      //console.log("this.bundle.activeRowIndex: " + this.bundle.activeRowIndex)
      //console.log("MANUALVal: " + MANUALVal)
      //console.log("CASHFROMBANKID: " + this.bundle.records[rowIndex].CASHFROMBANKID)

      if (MANUALVal === true) {
        this.LlModelsService.NG_LL_model_AR_cash_reconcileList_manualMatch_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'ADD');
      } else {
        this.LlModelsService.NG_LL_model_AR_cash_reconcileList_manualMatch_edit(this.bundle.records[rowIndex].CASHFROMBANKID, 'REMOVE');
      }


    }
    

    if (dataField === 'NOTES' && this.bundle.activeCODE === "Bank-Matched-No") {
      this.bundle.activeRowIndex = rowIndex;
      this.openUserNotes();
    }

    if (dataField === 'EDITLOC') {
      this.bundle.activeRowIndex = rowIndex;
      this.openEditLoc();
    }

  }

  selectAll() {
    if (this.bundle.activeCODE === "Auto-Match") {

      this.bundle.allSelected = true;

      var rows = this.datagrid.getdisplayrows();
      this.bundle.selectedRecords.slice(0);

     for (let k = 0; k < rows.length; k++) {
        this.bundle.records[rows[k].uid].SELECTED = true;
        this.bundle.records[rows[k].uid].ROWIDEX = rows[k].uid;

        this.bundle.selectedRecords[this.bundle.selectedRecords.length] = this.bundle.records[rows[k].uid];
      }

      this.datagrid.updatebounddata('cells');

      ///console.log(this.bundle.selectedRecords)
    
      this.LlModelsService.NG_LL_model_AR_cash_reconcileList_suggested_edit(this.bundle.selectedRecords, 'Accept');
    }
  }

  deSelectAll() {
    if (this.bundle.activeCODE === "Auto-Match") {

      this.bundle.allSelected = false;

      var rows = this.datagrid.getdisplayrows();
      this.bundle.selectedRecords.slice(0);

      for (let k = 0; k < rows.length; k++) {
        this.bundle.records[rows[k].uid].SELECTED = false;
        this.bundle.records[rows[k].uid].ROWIDEX = rows[k].uid;

        this.bundle.selectedRecords[this.bundle.selectedRecords.length] = this.bundle.records[rows[k].uid];
      }

      this.datagrid.updatebounddata('cells');

      ///console.log(this.bundle.selectedRecords)
      this.LlModelsService.NG_LL_model_AR_cash_reconcileList_suggested_edit(this.bundle.selectedRecords, 'Reject');
    }
  }

  onMonthChange(event: any): void {
    const newCHOICE = event.target.value;

    this.LlModelsService.setRECONMONTHCHOICE(newCHOICE);

    setTimeout(() => {
      this.bundle.activeCODE = "locations";
      this.getGridData() 
    });    
  }

  onLocationChange(event: any): void {
    const newLocationId = event.target.value;
    this.LlModelsService.setLOCATIONID_ACTIVE(newLocationId)

    setTimeout(() => {
      this.getGridData() 
    });    
  }

  onStateChange(event: any): void {
    const newSateId = event.target.value;

    this.LlModelsService.setSTATEID_ACTIVE(newSateId)

    setTimeout(() => {
      this.getGridData() 
    });    
  }

  selectTab(code) {
    this.bundle.showHorzTabs = false;
    this.bundle.activeCODE = code;
    this.getGridData();
  }

  clearMode() {
    this.bundle.mode = '';
  }

  showUserNotesPopup = false;
  popupTop = 150;
  popupLeft = 300;

  // Dragging variables
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private startLeft = 0;
  private startTop = 0;

  startDragging(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.clientX;
    this.startY = event.clientY;

    const popup = document.getElementById('userNotes');
    if (popup) {
      this.startLeft = parseFloat(popup.style.left) || 300;
      this.startTop = parseFloat(popup.style.top) || 150;
    }
    event.preventDefault();
  }


  @HostListener('document:mousemove', ['$event'])
  onDragging(event: MouseEvent) {
    if (!this.isDragging) return;

    const dx = event.clientX - this.startX;
    const dy = event.clientY - this.startY;

    this.popupLeft = this.startLeft + dx;
    this.popupTop = this.startTop + dy;
  }

  @HostListener('document:mouseup')
  stopDragging() {
    this.isDragging = false;
  }

  openUserNotes() {
    this.bundle.newUSERNOTE = '';
    this.bundle.newCASHUSERCHOICEID = 0;

    if (this.bundle.canManualMatch) {
      this.LlModelsService.NG_LL_model_AR_cash_list_remitsByAmount_get(
        (arr: any[]) => {
          this.bundle.remitsByAmount = arr || [];

          console.log("remitsByAmnt_RETURN")
          console.log(this.bundle.remitsByAmount)

          this.showUserNotesPopup = true;  

        },
        this.bundle.records[this.bundle.activeRowIndex].CASHFROMBANKID
      );

    } else {
      this.showUserNotesPopup = true;  
    }


    
  }

  closeUserNotes() {
    this.showUserNotesPopup = false;
  }

  newUserNote(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    this.bundle.newUSERNOTE = value;
  }

  newCASHUSERCHOICEID(event: any) {
    this.bundle.newCASHUSERCHOICEID = event;
  }

  saveUserNotes(): void {

    let ACTION = 'none';

    if (this.bundle.newCASHUSERCHOICEID != 0) {
      let choiceLable = this.getCASHFROMBANKIDLable(this.bundle.newCASHUSERCHOICEID);
      this.bundle.records[this.bundle.activeRowIndex].CASHUSERCHOICEID = this.bundle.newCASHUSERCHOICEID;
      this.bundle.records[this.bundle.activeRowIndex].CASHUSERCHOICE = choiceLable;
      ///console.log("saveUserNotes - choiceLable:" + choiceLable)
    }

    if (this.bundle.newUSERNOTE != '') {

      ACTION = 'NewNote';

      this.bundle.newUSERNOTE = (this.bundle.newUSERNOTE || '')
        .replace(/,/g, '')           // remove commas
        .trim();                     // remove leading/trailing spaces

      const todayDateOnly = new Date().toISOString().split('T')[0];
      let initials = this.UserService.getUserInitials();
      this.bundle.newUSERNOTE = todayDateOnly + " " + initials + ": " + this.bundle.newUSERNOTE;
      this.bundle.records[this.bundle.activeRowIndex].USERNOTES = this.bundle.newUSERNOTE + "," + this.bundle.records[this.bundle.activeRowIndex].USERNOTES;
      this.bundle.records[this.bundle.activeRowIndex].LASTUSERCHOICENOTE = this.bundle.newUSERNOTE;
      ///console.log("saveUserNotes - newUserNote:" + this.bundle.newUSERNOTE)
    }

    let CASHFROMBANKID = this.bundle.records[this.bundle.activeRowIndex].CASHFROMBANKID;
    let USERNOTES = this.bundle.records[this.bundle.activeRowIndex].USERNOTES;

    this.LlModelsService.NG_LL_model_AR_cash_list_userChoices_edit(CASHFROMBANKID, this.bundle.newCASHUSERCHOICEID, ACTION, USERNOTES);

    this.datagrid.updatebounddata('cells');

    this.showUserNotesPopup = false;
  }


  get cashUserChoiceId(): number {
    return this.bundle.records?.[this.bundle.activeRowIndex]?.CASHUSERCHOICEID || '';
  }

  get getUserNotes(): string {
    let userNotes = this.bundle.records?.[this.bundle.activeRowIndex]?.USERNOTES || '';

    if (!userNotes || userNotes.trim() === '') {
      return '';
    }

    // Split by comma and clean each item
    const notesArray = userNotes.split(',')
      .map(note => note.trim())           // remove extra spaces
      .filter(note => note !== '');       // remove empty entries

    // Reassemble with a line break between each
    return notesArray.join('\n');
  }



  showEditLocPopup = false;
  popupTop_editLoc = 150;
  popupLeft_editLoc = 50;

  // Dragging variables
  private isDragging_editLoc = false;
  private startX_editLoc = 0;
  private startY_editLoc = 0;
  private startLeft_editLoc = 0;
  private startTop_editLoc = 0;

  startDragging_editLoc(event: MouseEvent) {
    this.isDragging_editLoc = true;
    this.startX_editLoc = event.clientX;
    this.startY_editLoc = event.clientY;

    const popup = document.getElementById('editLoc');
    if (popup) {
      this.startLeft_editLoc = parseFloat(popup.style.left) || 300;
      this.startTop_editLoc = parseFloat(popup.style.top) || 150;
    }
    event.preventDefault();
  }


  @HostListener('document:mousemove', ['$event'])
  onDragging_editLoc(event: MouseEvent) {
    if (!this.isDragging_editLoc) return;

    const dx = event.clientX - this.startX_editLoc;
    const dy = event.clientY - this.startY_editLoc;

    this.popupLeft_editLoc = this.startLeft_editLoc + dx;
    this.popupTop_editLoc = this.startTop_editLoc + dy;
  }

  @HostListener('document:mouseup')
  stopDragging_editLoc() {
    this.isDragging_editLoc = false;
  }

  openEditLoc() {
    //this.bundle.newUSERNOTE = '';
    //this.bundle.newCASHUSERCHOICEID = 0;
    this.showEditLocPopup = true;
  }

  closeEditLoc() {
    this.showEditLocPopup = false;
  }
   

  newLOCATIONACCOUNTID(event: any) {

    console.log(event)

    this.bundle.newCashBankLocationAccountId = event;
  }

  saveEditLoc(): void {
    console.log(this.bundle.newCashBankLocationAccountId)
    //console.log(this.bundle.bankAccountList)

    let newLocName = "";

    for (let k = 0; k < this.bundle.bankAccountList.length; k++) {
      if (this.bundle.bankAccountList[k].CASHBANKLOCATIONACCOUNTID == this.bundle.newCashBankLocationAccountId) {
        newLocName = this.bundle.bankAccountList[k].LOCATIONNAME;
        break
      }
    }

    this.bundle.records[this.bundle.activeRowIndex].LOCATIONNAME = newLocName;
    this.bundle.records[this.bundle.activeRowIndex].CASHBANKLOCATIONACCOUNTID = this.bundle.newCashBankLocationAccountId;

    //console.log("newLocName:"+newLocName)

    let CASHFROMBANKID = this.bundle.records[this.bundle.activeRowIndex].CASHFROMBANKID;

    ///console.log("CASHFROMBANKID: " + CASHFROMBANKID)
 
    this.LlModelsService.NG_LL_model_AR_cash_list_cashBankAccount_edit(CASHFROMBANKID, this.bundle.newCashBankLocationAccountId);

    this.datagrid.updatebounddata('cells');

    this.showEditLocPopup = false;
  }


  getCASHFROMBANKIDLable(CASHUSERCHOICEID) {
    for (let k = 0; k < this.bundle.userChoices.length; k++) {
      if (this.bundle.userChoices[k].CASHUSERCHOICEID == CASHUSERCHOICEID) {
        return this.bundle.userChoices[k].CASHUSERCHOICE;       
      }
    }
  } 


  exportOnClick() {

    let label = this.bundle.activeCODE;

    for (let k = 0; k < this.bundle.columns.length; k++) {

      this.bundle.columns[k].STUDYCOLUMNQUESTIONIDALPHA = this.bundle.columns[k].datafield;
      this.bundle.columns[k].STUDYCOLUMNLABEL = this.bundle.columns[k].text
      this.bundle.columns[k].SYSTEMORGANIZATIONFIELDCODE = this.bundle.columns[k].datafield
    }

    var rows = this.datagrid.getdisplayrows();

    this.LlUtilityService.saveCSV(rows, this.bundle.columns, label)

  };

}
